import React from "react";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";

const TasksControls = ({
  searchTerm,
  onSearchChange,
  rowsPerPage,
  onRowsPerPageChange,
  totalTasks,
}) => {
  return (
    <Box
      sx={{
        mb: 3,
        display: "flex",
        gap: 2,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <TextField
        label="Search tasks"
        variant="outlined"
        size="small"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ minWidth: 200, mb: 0 }}
        placeholder="Search by title or description..."
      />
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Rows per page</InputLabel>
        <Select
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(e.target.value)}
          label="Rows per page"
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      <Typography variant="body2" color="text.secondary">
        Total: {totalTasks} tasks
      </Typography>
    </Box>
  );
};

export default TasksControls;
